import { useTranslation } from 'react-i18next';
import { ContentBackground, ContentBody, ContentHeader, ContentWrapper } from '@/components/content';
import { withPrivateRoute } from '@/components/hoc/withPrivateRoute';
import { ContainerFluid, Section } from '@/components/layouts';
import RootLayout from '@/components/layouts/RootLayout';
import { ROLES_PERMISSIONS } from '@/constants';
import { QueryParamsProvider } from '@/contexts/query-params/QueryParamsProvider';
import ClientContactsView from './_components/ClientContactsView';

/**
 * The client contacts on their own, for an HLB person whose only role is
 * employee: the team board stays closed to them, so this page asks nothing of it.
 */
function TeamContactsContent() {
  const { t } = useTranslation('teamContacts');
  return (
    <RootLayout metadata={{ title: t('tab') }}>
      <ContentBackground source="/assets/images/bg-pattern.svg" />
      <Section>
        <ContainerFluid className="foreground-wrapper">
          <ContentWrapper>
            <ContentHeader title={t('tab')} />
            <ContentBody>
              <div className="with-y-overflow overflow-x-hidden">
                <div className="grid grid-cols-[minmax(0,1fr)] gap-4 p-4">
                  <QueryParamsProvider>
                    <ClientContactsView />
                  </QueryParamsProvider>
                </div>
              </div>
            </ContentBody>
          </ContentWrapper>
        </ContainerFluid>
      </Section>
    </RootLayout>
  );
}

const TeamContactsPage = withPrivateRoute(TeamContactsContent, ROLES_PERMISSIONS.TEAM_CONTACTS.VIEW);
TeamContactsPage.displayName = 'TeamContactsPage';

export default TeamContactsPage;
